import { Button } from "@/components/ui/button";
import { joinZones, parseZones } from "@/lib/schema";

// 3x3 toggle grid. `cells` come from the structure (reachZones.cells, rows Upper/Middle/Lower).
// `groups` (reachZones.groups) drive the quick buttons. Value is the Zones string.
export default function ZoneGrid({ value, onChange, cells, groups, readOnly, reached }) {
  const selected = new Set(parseZones(value, cells));
  const reachedSet = reached ? new Set(parseZones(reached, cells)) : null;
  const set = (list) => !readOnly && onChange(joinZones(list, cells));
  const toggle = (c) => {
    const next = new Set(selected);
    next.has(c) ? next.delete(c) : next.add(c);
    set([...next]);
  };
  const quick = Object.keys(groups || {}).filter((g) => g !== "All");

  return (
    <div data-testid="zone-grid">
      <div className="inline-grid grid-cols-3 gap-1.5">
        {cells.map((c) => {
          const on = selected.has(c);
          const hit = reachedSet?.has(c);
          return (
            <button
              key={c}
              type="button"
              disabled={readOnly}
              title={c}
              data-testid={`zone-${c}`}
              onClick={() => toggle(c)}
              className={`h-12 w-16 rounded-md border text-[10px] leading-tight transition-colors ${
                on ? "bg-purple-600 border-purple-700 text-white" : "bg-white border-slate-200 text-slate-500 hover:bg-purple-50"
              } ${hit ? "ring-2 ring-emerald-400" : ""} ${readOnly ? "opacity-70 cursor-not-allowed" : ""}`}
            >
              {c.replace(/(Upper|Middle|Lower)/, "$1\n")}
            </button>
          );
        })}
      </div>
      {!readOnly && (
        <div className="flex flex-wrap gap-1.5 mt-2">
          {quick.map((g) => (
            <Button key={g} type="button" size="sm" variant="outline" className="h-7 px-2 text-xs"
              onClick={() => set(groups[g])}>{g}</Button>
          ))}
          <Button type="button" size="sm" variant="outline" className="h-7 px-2 text-xs" onClick={() => set(cells)}>All</Button>
          <Button type="button" size="sm" variant="outline" className="h-7 px-2 text-xs" onClick={() => set([])}>Clear</Button>
        </div>
      )}
      <div className="text-[11px] text-slate-400 mt-1 font-mono">{value || "None"}</div>
      {reachedSet && <div className="text-[11px] text-emerald-700 mt-1">Green ring = zones the patient reached</div>}
    </div>
  );
}
